<template>
    <o-table :title="$t('sandoz.customer_logins')" ref="tableList" url="/api/sandoz/customer_logins?include=external_ids" default-sort-by-direction="desc" default-sort-by="id" :custom-delete="true">
        <template slot="filter">
            <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                <o-filter-text :title="$t('core.email')" column="email"></o-filter-text>
                <o-filter-text :title="$t('sandoz.customer_external_id')" column="external_id"></o-filter-text>
                <o-filter-select :items="options" :title="$t('sandoz.missing_active_externalid')" column="active_external_id" value-field="value" text-field="text"></o-filter-select>
            </o-filter>
        </template>
        <template slot="head">
            <o-table-header column="id">{{$t('core.id')}}</o-table-header>
            <o-table-header column="email">{{$t('core.email')}}</o-table-header>
            <o-table-header column="agreed_to_terms">{{$t('sandoz.agreed_to_terms')}}</o-table-header>
            <o-table-header column="year_from">{{$t('sandoz.year_from')}}</o-table-header>
            <o-table-header column="year_to">{{$t('sandoz.year_to')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>
              <template v-if="props.item.inactive_contract_externalid > 0">
                <fa icon="exclamation-circle" style="color:red;"/>
              </template>
              {{ props.item.id }}</td>
            <td>{{ props.item.email }}</td>
            <td>
              {{props.item.agreed_to_terms ? $t('sandoz.yes') : $t('sandoz.no')}}
            </td>
            <td>{{ props.item.year_from }}</td>
            <td>{{ props.item.year_to }}</td>
        </template>
        <template slot="body-controls" slot-scope="props">
            <td class="text-right">
              <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                <b-btn @click="impersonateUser(props.item)">
                  <fa icon="sign-in-alt"/>
                </b-btn>

                <o-delete method="delete" :custom-delete="true" :url="$refs.tableList.deleteUrl() + '/' + props.item.id" v-on:action-executed="$refs.tableList.search"></o-delete>
                <router-link :to="{ path: $route.path + '/' + props.item.id }" class="btn btn-primary">
                  <fa icon="pencil-alt"/>
                </router-link>
              </div>
            </td>
        </template>
    </o-table>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    data: () => ({
      options: []
    }),
    created() {
      this.options = [
        {value: 'inactive', text: this.$i18n.t('sandoz.yes')},
        {value: 'active', text: this.$i18n.t('sandoz.no')},
      ]
    },
    computed: {
      ...mapGetters({
        user: 'auth/user'
      })
    },
    methods: {
      impersonateUser(customerLogin) {
        window.open('/customer/' + customerLogin.id + '?token=' + this.$store.getters['auth/token'])
      }
    }
  }
</script>
